var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      key: "refer-a-friend-modal-" + Math.random(),
      attrs: {
        id: "refer-modal",
        "no-border-radius": true,
        small: true,
        "show-close-button": true,
        isReferralModal: true
      },
      on: { close: _vm.bubbleClose }
    },
    [
      _c("Blurb", {
        attrs: {
          title: _vm.content.title,
          description: _vm.content.description,
          "button-text": _vm.content.buttonText,
          "image-src": "/site_media/version-0/images/referral/piggy.svg",
          "image-alt": "Saving piggy",
          "large-theme": true,
          "referral-theme": true,
          loading: _vm.loading
        },
        on: { "button-clicked": _vm.content.buttonHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }